import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Handles protocol handler deeplinks (web+agenti:...) when app opens with ?link= */
export const ProtocolLinkHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const link = params.get("link");
    if (!link || !link.startsWith("web+agenti:")) return;

    const path = link.slice("web+agenti:".length).trim();
    if (!path) return;

    const route = path.startsWith("/") ? path : `/${path}`;
    navigate(route, { replace: true });
  }, [navigate]);

  return null;
};
